/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface QuestionnaireInstanceUpdatePatchParams {
    questionnaireInstanceGuid: string;
    isTest: boolean;
}

export function questionnaireInstanceUpdatePatch(http: HttpClient, rootUrl: string, headers: HttpHeaders, params: QuestionnaireInstanceUpdatePatchParams, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, questionnaireInstanceUpdatePatch.PATH, 'patch');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params) {
        rb.path('questionnaireInstanceGuid', params.questionnaireInstanceGuid, {"style":"simple"});
    }

    rb.body({ isTest: params.isTest });

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<void>;
        })
    );
}

questionnaireInstanceUpdatePatch.PATH = '/api/v1/questionnaire-instances/{questionnaireInstanceGuid}';
